<template>
  <div class="whole">
    <h3>{{$t("title.Introduction of Video Train")}}</h3>
    <hr/>
    <div class="text">
      <br/>
      <h4>
      <router-link :to="{ name: 'videoPlay', params: { title: $t('video.Cultural and Tourism Product Investment'), videoUrl: getVideoLink('Cultural_and_Tourism_Product_Investment') }}">{{ $t("video.Cultural and Tourism Product Investment") }}</router-link>
      </h4>
        <div class="videoIntro">
        {{$t("video.Introduction of Cultural and Tourism Product Investment")}}<br/>
      </div>
      <br/>
      <h4>
        <router-link :to="{ name: 'videoPlay', params: { title: $t('video.Sustainable Travel and Tourism'), videoUrl: getVideoLink('Sustainable_Travel_and_Tourism') }}">
          {{ $t("video.Sustainable Travel and Tourism") }}
        </router-link>
      </h4>
      <div class="videoIntro">
        {{$t("video.Introduction of Sustainable Travel and Tourism")}}<br/>
      </div>
      <br/>
      <h4>
        <router-link :to="{ name: 'videoPlay', params: { title: $t('video.Innovative Technology'), videoUrl: getVideoLink('Innovative_Technology') }}">
          {{ $t("video.Innovative Technology") }}
        </router-link>
      </h4>
      <div class="videoIntro">
        {{$t("video.Introduction of Innovative Technology")}}<br/>
      </div>
      <br/>
      <h4>
        <router-link :to="{ name: 'videoPlay', params: { title: $t('video.Market Logic and Evolution of Sports Tourism'), videoUrl: getVideoLink('Market_Logic_and_Evolution_of_Sports_Tourism') }}">
          {{ $t("video.Market Logic and Evolution of Sports Tourism") }}
        </router-link>
      </h4>
      <div class="videoIntro">
        {{$t("video.Introduction of Market Logic and Evolution of Sports Tourism")}}<br/>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "videoTrain",
  data() {
    return {
    }
  },
  methods: {
    getVideoLink(videoName) {
      // 根据当前语言选择不同的视频文件
      const lang = this.$i18n.locale === 'cn' ? 'Ch' : 'En';
      return `${videoName}_${lang}.mp4`;
    },
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.whole{
  overflow: hidden;
}
.videoIntro{
  margin-right: 30px;
  margin-left: 30px;
}
</style>